// extracted by mini-css-extract-plugin
module.exports = {"BenefitsTable":"BenefitsTable_BenefitsTable__IS8zI"};